import useUser from '@/modules/auth/composables/use-user'

export default function useOrganizationFlags() {
    const { organization } = useUser()

    return {
        hasFlag(flag: string): boolean {
            return !!organization.value?.flags?.[flag] && organization.value.flags[flag] !== 'false'
        },
        getFlag(flag: string) {
            return organization.value?.flags?.[flag]
        },
    }
}
